import React, { useContext, useEffect, useState } from "react";
import AppContainer from "../Structure/AppContainer";
import ajaxAccounting from "../../util/remote/ajaxAccounting";
import Select from "react-select";
import ajaxProject from "../../util/remote/ajaxProject";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../Common/Loader";
import AuthContext from "../../Context/AuthContext";
import ajaxUser from "../../util/remote/ajaxUser";
function PaymentVoucherCreate(props) {
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState("");
  const [projectID, setProjectID] = useState("");
  const [LedgerID_credited, setLedgerID_credited] = useState("");
  const [LedgerID_debited, setLedgerID_debited] = useState("");
  const [description, setDescription] = useState("");
  const [cost_item, setCost_item] = useState("");
  const [date, setDate] = useState("");
  const [reciever, setReciever] = useState("");
  const [employee, setEmployee] = useState("");
  const [trans_type, setTrans_type] = useState("payment_voucher");
  const [invoice_reff, setInvoice_reff] = useState("");
  const [Supplier_ivoice_reff, setSupplier_ivoice_reff] = useState([]);
  const [voucher_no, setVoucher_no] = useState("");
  const { user, userId } = useContext(AuthContext);
  const [totalInvoiceAmount, setTotalInvoiceAmount] = useState(0);
  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setDate(today);
  }, []);
  const handleAdd = async (e) => {
    e.preventDefault();
    if (
      projectID.trim() === "" ||
      LedgerID_credited.trim() === "" ||
      LedgerID_debited.trim() === "" ||
      amount.trim() === "" ||
      date.trim() === "" ||
      LedgerID_credited === LedgerID_debited // checks  if the ledgers selected are not the same
    ) {
      toast.error(
        "Please complete all fields and make sure the selected ledger are (s) are not the same"
      );
    } else if (
      Supplier_ivoice_reff.length > 0 &&
      parseFloat(amount) > totalInvoiceAmount
    ) {
      toast.error("Amount exceeds the total of selected invoices");
      return;
    } else {
      setLoading(true);
      var data = {
        folioID: "",
        amount: amount,
        projectID: projectID,
        LedgerID_debited: LedgerID_debited,
        LedgerID_credited: LedgerID_credited,
        cost_item: cost_item,
        date: date,
        reciever: reciever,
        employee: employee,
        created_by: userId,
        trans_type: trans_type,
        description: description,
        Supplier_ivoice_reffs: Supplier_ivoice_reff.map(
          (invoice) => invoice.id
        ),
        voucher_no: voucher_no,
        invoice_reff: invoice_reff,
      };
      const server_response = await ajaxAccounting.CreatePaymentVoucher(data);
      setLoading(false);
      if (server_response.status === "OK") {
        toast.success(server_response.message);
        props.function();
        getsupplierInvoices();
        resetForm();
      } else {
        toast.error(server_response.message);
      }
    }
  };
  const resetForm = () => {
    setProjectID("");
    setAmount("");
    setCost_item("");
    setLedgerID_credited("");
    setLedgerID_debited("");
    setDescription("");
    setVoucher_no("");
    setReciever("");
    setSupplier_ivoice_reff([]);
    setTotalInvoiceAmount(0);
  };
  const [Debitledgers, setDebitledgers] = useState("");
  const getDebitlegders = async () => {
    const server_response =
      await ajaxAccounting.getALlLedgersMinData_non_cash_or_bank();
    if (server_response.status === "OK") {
      setDebitledgers(server_response.details);
    } else {
      setDebitledgers("404");
    }
  };
  const [creditLedger, setCreditLedger] = useState("");
  const getCreditlegders = async () => {
    const server_response =
      await ajaxAccounting.getALlLedgersMinData_cash_or_bank();
    if (server_response.status === "OK") {
      setCreditLedger(server_response.details);
    } else {
      setCreditLedger("404");
    }
  };
  // Supplier_ivoice_reff invoices works
  const [supinvoices, setISupinvoices] = useState("");
  const [filteredInvoices, setFilteredInvoices] = useState([]); // State for filtered invoices
  const getsupplierInvoices = async () => {
    const server_response = await ajaxAccounting.getSupplierInvoiceReferences();
    if (server_response.status === "OK") {
      setISupinvoices(server_response.details);
      setFilteredInvoices(server_response.details);
    } else {
      setISupinvoices("");
    }
  };
  const handleLedgerChanging = (e) => {
    if (e) {
      setLedgerID_debited(e.id);
      const selected = e.id;
      const filtered = supinvoices.filter((inv) => inv.ledgerID === selected);
      setSupplier_ivoice_reff([]);
      setFilteredInvoices(filtered);
    }
  };
  const handleInvoiceChange = (selected) => {
    const selectAllOption = selected?.find((item) => item.value === "*");
    if (selectAllOption) {
      const allInvoices = filteredInvoices;
      setSupplier_ivoice_reff(allInvoices);
      const totalAmount = allInvoices.reduce(
        (sum, invoice) => sum + parseFloat(invoice.balance || 0),
        0
      );
      setTotalInvoiceAmount(totalAmount);
    } else {
      setSupplier_ivoice_reff(selected);
      const totalAmount = selected.reduce(
        (sum, invoice) => sum + parseFloat(invoice.balance || 0),
        0
      );
      setTotalInvoiceAmount(totalAmount);
    }
  };
  // ledgers fetching +++++++++++++++
  useEffect(() => {
    getDebitlegders();
    getCreditlegders();
    getsupplierInvoices();
  }, []);
  const [employees, setEmployees] = useState("");
  const getEmployees = async () => {
    const server_response = await ajaxUser.getUsersMinimal_data();
    if (server_response.status === "OK") {
      setEmployees(server_response.details);
    } else {
      setEmployees("404");
    }
  };
  const [projects, setProjects] = useState("");
  const getProjects = async () => {
    const server_response = await ajaxProject.getProjectsMinnimalDataCliented();
    if (server_response.status === "OK") {
      setProjects(server_response.details);
    } else {
      setProjects("404");
    }
  };
  const [cost_allocations, setCost_allocations] = useState("");
  const getCost_Allocations = async () => {
    const server_response =
      await ajaxAccounting.getAllcostAllocations_min_data();
    if (server_response.status === "OK") {
      setCost_allocations(server_response.details);
    } else {
      setCost_allocations("404");
    }
  };
  useEffect(() => {
    getProjects();
    getCost_Allocations();
    getEmployees();
  }, []);
  const formatCurrency = (value) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "Ugx",
    }).format(value);
  };
  // end posting works
  return (
    <div>
      <Toaster />
      <div className="col-lg-12 col-md-12">
        <div className="card custom-card" style={{ borderRadius: "10px" }}>
          <div className="card-body">
            <div>
              <h6 className="card-title mb-4">Add Payment Voucher</h6>
            </div>
            <form onSubmit={(e) => handleAdd(e)} method="post">
              <div className="row">
                <input
                  type="hidden"
                  value={trans_type}
                  onChange={(e) => setTrans_type(e.target.value)}
                  className="form-control"
                />
                <div className="mb-4 col-md-3">
                  <label htmlFor="">
                    select project
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    onChange={(e) => setProjectID(e.id)}
                    getOptionLabel={(option) => option.project_name}
                    getOptionValue={(option) => option.id}
                    isSearchable
                    options={projects}
                    value={
                      projectID
                        ? Array.isArray(projects) &&
                          projects.find((value) => value.id === projectID)
                        : ""
                    }
                  />
                </div>
                <div className="mb-4 col-md-4">
                  <label htmlFor="">
                    Select Account To Debit
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    onChange={(e) => handleLedgerChanging(e)}
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.id}
                    isSearchable
                    options={Array.isArray(Debitledgers) ? Debitledgers : []}
                    value={
                      LedgerID_debited
                        ? Array.isArray(Debitledgers) &&
                          Debitledgers.find(
                            (value) => value.id === LedgerID_debited
                          )
                        : ""
                    }
                  />
                </div>
                <div className="mb-4 col-md-4">
                  <label htmlFor="">
                    Select Account To Credit
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    onChange={(e) => setLedgerID_credited(e.id)}
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.id}
                    isSearchable
                    options={Array.isArray(creditLedger) ? creditLedger : []}
                    value={
                      LedgerID_credited
                        ? Array.isArray(creditLedger) &&
                          creditLedger.find(
                            (value) => value.id === LedgerID_credited
                          )
                        : ""
                    }
                  />
                </div>
                <div className="mb-4 col-md-4">
                  <label htmlFor="">cost allocation center</label>
                  <Select
                    onChange={(e) => setCost_item(e.id)}
                    getOptionLabel={(option) => option.item}
                    getOptionValue={(option) => option.id}
                    isSearchable
                    options={
                      Array.isArray(cost_allocations) ? cost_allocations : [""]
                    }
                    value={
                      cost_item
                        ? Array.isArray(cost_allocations) &&
                          cost_allocations.find(
                            (value) => value.id === cost_item
                          )
                        : ""
                    }
                  />
                </div>
                <div className="mb-4 col-md-4">
                  <label htmlFor="">Supplier Invoice</label>
                  <Select
                    onChange={(e) => handleInvoiceChange(e)}
                    getOptionLabel={(option) => option.label || option.reff}
                    getOptionValue={(option) => option.value || option.id}
                    isMulti
                    isSearchable
                    options={
                      LedgerID_debited
                        ? [
                            { label: "Select All", value: "*" },
                            ...filteredInvoices.map((inv) => ({
                              ...inv,
                              label: `${inv.reff}`,
                              value: inv.id,
                            })),
                          ]
                        : []
                    }
                    value={Supplier_ivoice_reff}
                  />
                </div>
                <div className="mb-4 col-md-4">
                  <label htmlFor="">
                    <></>
                    Amount{" "}
                    <span style={{ color: "red" }}>
                      * {formatCurrency(totalInvoiceAmount)}
                    </span>
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    className="form-control"
                  />
                </div>
                <div className="mb-4 col-md-4">
                  <label htmlFor="">
                    Legger_reference{" "}
                    <span style={{ color: "red" }}>for old Ledgers</span>
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    value={voucher_no}
                    onChange={(e) => setVoucher_no(e.target.value)}
                    className="form-control"
                    placeholder="ledger reference"
                  />
                </div>
                <div className="mb-4 col-md-4">
                  <label htmlFor="">
                    Reciever
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    value={reciever}
                    onChange={(e) => setReciever(e.target.value)}
                    className="form-control"
                  />
                </div>
                <div className="mb-4 col-md-4">
                  <label htmlFor="">Employee</label>
                  <Select
                    onChange={(e) => setEmployee(e.id)}
                    getOptionLabel={(option) => option.User_name}
                    getOptionValue={(option) => option.id}
                    isSearchable
                    options={Array.isArray(employees) ? employees : [""]}
                    value={
                      employee
                        ? Array.isArray(employees) &&
                          employees.find((value) => value.id === employee)
                        : ""
                    }
                  />
                </div>
                <div className="mb-4 col-md-4">
                  <label htmlFor="">
                    Date
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="date"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    className="form-control"
                  />
                </div>
                <div className="mb-4 col-md-12">
                  <label htmlFor="">
                    Description
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <textarea
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    className="form-control"
                  ></textarea>
                </div>
              </div>
              <div className="col-md-12 col-lg-12">
                <input
                  disabled={loading}
                  type="submit"
                  style={{ borderRadius: "10px" }}
                  className="btn btn-success col-lg-12"
                  value="Save Payment Voucher"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
export default PaymentVoucherCreate;
